import { Cancel } from '@mui/icons-material';
import { ReactElement } from 'react';
import { ListButton, ListButtonProps } from 'react-admin';

export default function CancelButton(props: ListButtonProps): ReactElement {
  return <ListButton icon={<Cancel />} label="Cancel" {...props} />;
}
